/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gateway_Sub_Spend_Pending_InvoiceInputs */



/**
* | output |
* | --- |
* | "Will appear on next invoice" |
*
* @param {Gateway_Sub_Spend_Pending_InvoiceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const gateway_sub_spend_pending_invoice = /** @type {((inputs?: Gateway_Sub_Spend_Pending_InvoiceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gateway_Sub_Spend_Pending_InvoiceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erscheint auf der nächsten Rechnung")
	return /** @type {LocalizedString} */ ("Will appear on next invoice")
});